const ErrorPage = () =>{

    return (
        <>
          <main>
             <h1>An error occured!</h1>
             <h1>Could not find this page!</h1>
            </main>
        </>
    );

};
export default ErrorPage;